// extracted by mini-css-extract-plugin
module.exports = {"one-video":"OneVideo_one-video__dO2Jp","full-width":"OneVideo_full-width__9x0Ho","video-container":"OneVideo_video-container__1iZvj"};